<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col cols="3">
          <v-card class="card-wrap">
            <v-card-title>
              <v-tooltip bottom :z-index="100">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ellipsis">Heep Memory</span>
                </template>
                <span>Heep Memory</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <heep-memory
                :system="system"
                :items="nodes"
                :values="rawJavaHeap"
                :formatter="formatter.rawJavaHeap"
                :max="100"
                :contextmenu="contextmenuHeap"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="card-wrap">
            <v-card-title>
              <v-tooltip bottom :z-index="100">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ellipsis">System Thread</span>
                </template>
                <span>System Thread</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <system-thread
                :system="system"
                :items="nodes"
                :values="rawJavaSstmThrd"
                :formatter="formatter.rawJavaSstmThrd"
                :contextmenu="contextmenuSstmThrd"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="card-wrap">
            <v-card-title>
              <v-tooltip bottom :z-index="100">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ellipsis">Application Thread</span>
                </template>
                <span>Application Thread</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <application-thread
                :system="system"
                :items="nodes"
                :values="rawJavaApplThrd"
                :formatter="formatter.rawJavaApplThrd"
                :contextmenu="contextmenuApplThrd"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="card-wrap">
            <v-card-title>
              <v-tooltip bottom :z-index="100">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ellipsis">JDBC Connection</span>
                </template>
                <span>JDBC Connection</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <jdbc-connection
                :system="system"
                :items="nodes"
                :values="rawJavaJdbcConn"
                :formatter="formatter.rawJavaJdbcConn"
                :contextmenu="contextmenuJdbcConn"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { cloneDeep } from 'lodash';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import HeepMemory from '../chart/BarVertical.vue';
import SystemThread from '../chart/BarVertical.vue';
import ApplicationThread from '../chart/BarVertical.vue';
import JdbcConnection from '../chart/BarVertical.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    HeepMemory,
    SystemThread,
    ApplicationThread,
    JdbcConnection,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/java/NodeSummary',
        title: 'Node Summary',
      },
      messages: [
        {
          name: 'rawJavaHeap',
          fields: ['stime', 'usedMemoryRate'],
        },
        {
          name: 'rawJavaSstmThrd',
          fields: ['stime', 'activeThreadsCount'],
        },
        {
          name: 'rawJavaApplThrd',
          fields: ['stime', 'activeThreadsCount'],
        },
        {
          name: 'rawJavaJdbcConn',
          fields: ['stime', 'usedRate'],
        },
      ],
      messageSequence: 0,
      values: {
        rawJavaHeap: {},
        rawJavaSstmThrd: {},
        rawJavaApplThrd: {},
        rawJavaJdbcConn: {},
      },
      rawJavaHeap: {},
      rawJavaSstmThrd: {},
      rawJavaApplThrd: {},
      rawJavaJdbcConn: {},
      formatter: {
        rawJavaHeap: param => `${param.value} %`,
        rawJavaSstmThrd: param => param.value,
        rawJavaApplThrd: param => param.value,
        rawJavaJdbcConn: param => `${param.value} %`,
      },
      contextmenuUrl: '',
    };
  },
  watch: {
    nodes: {
      handler: 'changeNodesHandler',
    },
  },
  methods: {
    contextmenuHeap(event) {
      this.contextmenuUrl = '/views/detailview/java/jm';
      this.onContextmenuChart(event);
    },
    contextmenuSstmThrd(event) {
      this.contextmenuUrl = '/views/detailview/java/ut';
      this.onContextmenuChart(event);
    },
    contextmenuApplThrd(event) {
      this.contextmenuUrl = '/views/detailview/java/ut';
      this.onContextmenuChart(event);
    },
    contextmenuJdbcConn(event) {
      this.contextmenuUrl = '/views/detailview/java/db';
      this.onContextmenuChart(event);
    },
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
        every(key, last.data, last.ctime, last.empty);
      });
    },
    wsDataHandler(key, response) {
      ++this.messageSequence;

      // 시스템 별 초기화
      if (this.messageSequence == 1) this.values[key.name] = {};

      response.forEach(res => {
        const field = this.messages.find(msg => msg.name == key.name).fields[1];
        this.values[key.name][key.nodeId] = res[field] || 0;
      });

      // 모든 인스턴스 값이 지정되었을 경우
      if (this.messageSequence == this.nodes.length) {
        Object.keys(this.values).forEach(key => (this[key] = cloneDeep(this.values[key])));
        this.messageSequence = 0;
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.nodes.reduce(
          (acc, node) =>
            acc.concat(
              this.messages.map(message => ({
                key: { name: message.name, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
                fields: message.fields,
                empty: false,
                handler: {
                  buffer: this.wsBufferedDataHandler,
                  every: this.wsDataHandler,
                },
              })),
            ),
          [],
        ),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // value init
      Object.keys(this.values).forEach(key => (this.values[key] = {}));
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeNodesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  width: 100px;
  overflow: hidden;
}
.chart-area {
  height: calc(100% - 37px);
}
</style>
